import { Tooltip } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { formatDistanceToNow } from 'date-fns';
import { FC } from 'react';

type EstimateLastViewedIndicatorProps = {
  lastViewedAt: string | null | undefined;
};

const EstimateLastViewedIndicator: FC<EstimateLastViewedIndicatorProps> = (
  props
) => {
  const { lastViewedAt } = props;
  if (!lastViewedAt) return null;

  return (
    <Tooltip
      tooltipContent={`Last viewed ${formatDistanceToNow(
        new Date(lastViewedAt),
        {
          addSuffix: true,
        }
      )}`}
    >
      <UntitledIcon
        name="eye.3"
        className="block size-4 text-blue-900"
        data-testid="estimate-last-viewed-indicator"
      />
    </Tooltip>
  );
};

export default EstimateLastViewedIndicator;
